<div class="context-menu"
  ngbDropdown
  display="dynamic"
  container="body"
  placement="bottom-left bottom-right"
  #dropdown="ngbDropdown">
  <app-tooltip [dynamic]="false" [message]="$safeNavigationMigration(contextMenuModel?.tooltip)" class="display-inline-flex">
    <span class="iwp-icon-gen_kontextmenu"
      [attr.data-cy]="contextMenuToggleDataCy"
      ngbDropdownToggle
    (click)="clickOnDropdownToggle(dropdown)"></span>
  </app-tooltip>
  <div ngbDropdownMenu [attr.data-cy]="contextMenuDataCy" class="override-context-menu-position">
    @for (entry of contextMenuModel?.items; track entry) {
      @if (hasVisualSeparator(entry)) {
        <div class="separator">
        </div>
      }
      <div ngbDropdownItem
        [disabled]="entry.disabled"
        data-cy="context-menu-option"
        (click)="!entry.disabled && entry.action()"><span>{{entry.label}}</span>
      </div>
    }
  </div>
</div>
